






import Vue from 'vue'
import SupportContentContainer from '@/containers/Support/Content'
import FetchFAQContentUseCase from '@/usecases/faq/FetchFAQContentUseCase'

export default Vue.extend({
  components: {
    SupportContentContainer
  },
  middleware: ['loginCheck'],
  async fetch({ $snapsnapGateway, $FAQRepository, params }) {
    try {
      const contentId = parseInt(params['contentId'], 10)
      const fetchContent = new FetchFAQContentUseCase({
        snapsnapGateway: $snapsnapGateway,
        FAQRepository: $FAQRepository
      })
      await fetchContent.execute(contentId)
    } catch (e) {
      throw e
    }
  },
  computed: {
    categoryId(): number {
      return parseInt(this.$route.params['categoryId'], 10)
    },
    contentId(): number {
      return parseInt(this.$route.params['contentId'], 10)
    }
  }
})
